import { render, staticRenderFns } from "./BreedHeader.vue?vue&type=template&id=54b29a33&scoped=true&"
import script from "./BreedHeader.vue?vue&type=script&lang=ts&"
export * from "./BreedHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BreedHeader.vue?vue&type=style&index=0&id=54b29a33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b29a33",
  null
  
)

export default component.exports